<template>
  <a-col class="project-competence">
    <div class="project-competence__title">Компетенции {{ index + 1 }}</div>

    <div v-if="errors.getError('id')" class="set_id_error">
      {{ errors.getError('id') }}
    </div>

    <a-row class="project-competence_set">
      <div class="project-competence_set__item">
        <label class="field__label"> Предметная область </label>
        <div :class="getCompetenceClass" v-if="model.competenceSubject?.name">
          {{ `#${model.competenceSubject?.name}` }}
        </div>
        <div class="placeholder" v-else />
      </div>
      <div class="project-competence_set__item">
        <label class="field__label"> Технологии </label>
        <div
          :class="getCompetenceClass"
          v-if="model.competenceTechnology?.name"
        >
          {{ `#${model.competenceTechnology?.name}` }}
        </div>
        <div class="placeholder" v-else />
      </div>
      <div class="project-competence_set__item">
        <label class="field__label"> Навыки </label>
        <div :class="getCompetenceClass" v-if="model.competenceSkill?.name">
          {{ `#${model.competenceSkill?.name}` }}
        </div>
        <div class="placeholder" v-else />
      </div>
    </a-row>
  </a-col>
</template>

<script setup>
  import { computed, onMounted, reactive, watch } from 'vue';
  import ErrorsHandler from '@/components/form/errors-handler';

  const props = defineProps({
    index: {
      type: Number,
      required: true,
    },
    competenceSet: Object,
    apiErrors: Object,
  });

  const model = reactive({
    id: null,
    status: null,
    competenceSubject: null,
    competenceTechnology: null,
    competenceSkill: null,
  });

  const getCompetenceClass = computed(() => {
    const classForStatus = model.status ? ` ${model.status}` : ' default';
    return 'competence' + classForStatus;
  });

  const errors = new ErrorsHandler({
    id: '',
  });

  onMounted(() => {
    fillModel();
  });

  watch(
    () => props.competenceSet,
    () => {
      fillModel();
    },
    { deep: true }
  );

  watch(
    () => props.apiErrors,
    () => {
      if (props.apiErrors && props.apiErrors['errors']) {
        errors.handleApiErrors(props.apiErrors);
      } else {
        errors.clearErrors();
      }
    }
  );

  const fillModel = () => {
    model.id = props.competenceSet.id;
    model.status = props.competenceSet.status;
    model.competenceSubject = props.competenceSet.competenceSubject;
    model.competenceTechnology = props.competenceSet.competenceTechnology;
    model.competenceSkill = props.competenceSet.competenceSkill;
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  * {
    font-family: Nunito Sans, sans-serif;
  }

  .project-competence {
    background: $color-bg-secondary-grey;
    border-radius: 6px;
    flex-direction: column;
    min-height: 303px;
    min-width: 325px;
    width: 325px;
    padding: 20px 14px;

    .set_id_error {
      color: $color-text-accent-red;
      margin-bottom: 14px;
    }

    &__title {
      color: $color-bg-status-new;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      text-align: left;
      margin-bottom: 20px;
    }

    &_set {
      column-gap: 20px;
      row-gap: 20px;
      padding: 0 10px;

      &__item {
        width: 100%;

        .field__label {
          color: $color-bg-status-new;
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
          margin-bottom: 8px;
        }

        .competence {
          color: $color-text-primary;
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
          width: fit-content;
          max-width: 276px;
          margin-top: 8px;
          padding: 4px 10px;
          border-radius: 5px;

          overflow: hidden;
          text-overflow: ellipsis;
          overflow-wrap: break-word;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;

          &.default {
            background-color: $color-text-secondary-white;
            border: 1px solid $color-bg-secondary-grey;
          }

          &.confirmed {
            background-color: rgba(114, 200, 30, 0.25);
            border: 1px solid $color-bg-status-done;
          }

          &.rejected {
            background-color: rgba(246, 81, 96, 0.1);
            border: 1px solid $color-text-accent-red;
          }
        }

        .placeholder {
          height: 28px;
        }
      }
    }
  }
</style>
